/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_African_Languages22Inputs */

const en__field__enum_studyprograms_study_african_languages22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_African_Languages22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`African Languages, Media and Communication`)
};

const de__field__enum_studyprograms_study_african_languages22 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_African_Languages22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikanische Sprachen, Medien und Kommunikation`)
};

/**
* | output |
* | --- |
* | "African Languages, Media and Communication" |
*
* @param {_Field__Enum_Studyprograms_Study_African_Languages22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_african_languages22 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_African_Languages22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_African_Languages22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_african_languages22(inputs)
	return de__field__enum_studyprograms_study_african_languages22(inputs)
});
export { _field__enum_studyprograms_study_african_languages22 as "_field__enum_studyPrograms_STUDY_AFRICAN_LANGUAGES" }